import { useEffect, useState } from "react";
import "./ConsentimentoCookie.css";
import React from "react";

const COOKIE_CONSENT_KEY = "COOKIE_CONSENT";

export default function ConsentimentoCookie() {
  const [consented, setConsented] = useState<boolean>(() => {
    return localStorage.getItem(COOKIE_CONSENT_KEY) === "true";
  });

  const consent = () => {
    const elemento = document.querySelector(".pwa-install") as HTMLElement;
    if (elemento) {
      elemento.style.bottom = "0px";
    }

    localStorage.setItem(COOKIE_CONSENT_KEY, "true");
    setConsented(true);
  };

  const goToLink = (url: string) => {
    window.open(url, "_blank");
  };

  if (consented) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-consent-text">
        <div>
          <span> Utilizamos cookies para o correto funcionamento deste site, bem como cookies para personalizar conteúdo e anúncios, fornecer recursos de mídia social e para obter informações estatísticas e analíticas do site. Se quiser saber mais sobre cookies e sobre a possibilidade de você bloqueá-los ou se quiser informações sobre como usamos dados, acesse nossa Aviso de Privacidade. </span>
          <span className="link" onClick={() => goToLink("https://www.yamahaservicosfinanceiros.com.br/aviso-de-privacidade")  }> {" "} Aviso de Privacidade. </span>
        </div>
      </div>

      <div>
        <button onClick={consent}>Entendi</button>
      </div>
    </div>
  );
}
